import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page Not Found | Tri-Cities Water Restoration" description="The requested page could not be found." robots="noindex,follow" />
      <section className="bg-secondary py-24">
        <div className="container-page text-center">
          <div className="text-sm font-semibold uppercase tracking-wider text-water-strong">404</div>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-primary">Page not found</h1>
          <p className="mx-auto mt-4 max-w-xl text-muted-foreground">The page may have moved or the address may be incorrect.</p>
          <Link to="/" className="mt-7 inline-flex rounded-full bg-navy-deep px-6 py-3 text-sm font-bold text-white hover:bg-navy">Return Home</Link>
        </div>
      </section>
    </>
  );
}
